import { render, staticRenderFns } from "./MemberBadgeItemParts.vue?vue&type=template&id=c2e32f2a&scoped=true"
import script from "./MemberBadgeItemParts.vue?vue&type=script&lang=ts"
export * from "./MemberBadgeItemParts.vue?vue&type=script&lang=ts"
import style0 from "./MemberBadgeItemParts.vue?vue&type=style&index=0&id=c2e32f2a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2e32f2a",
  null
  
)

export default component.exports